import { useCallback } from "react";
import useCompanyData from "./company";

export default function UsePerms() {

    const {userPerms, rootUser} = useCompanyData()
    
    const chkPerms = useCallback((permissions) => {
        if (rootUser) {
            return true
        }

        if (!permissions) {
            return false
        }
        
        return permissions.every( (val) => { return userPerms.find(x => x === val ) } )
    }, [userPerms, rootUser])

    return chkPerms
}